import { loginWithPassword, fetchUserInfo } from '@/api/auth';
import { sessionHelper } from './sessionHelper';
import type { LoggedInUser } from '@/api/types';

// High-level auth flows. Stores call these; UI components don't.

export async function performLogin(
  username: string,
  password: string,
  rememberMe: boolean
): Promise<LoggedInUser> {
  // Persist remember-me FIRST so subsequent saves go to the right storage.
  sessionHelper.saveRememberMe(rememberMe);

  const tokenResponse = await loginWithPassword({ username, password });
  sessionHelper.saveToken(tokenResponse.access_token);
  if (tokenResponse.refresh_token) {
    sessionHelper.saveRefreshToken(tokenResponse.refresh_token);
  }

  const info = await fetchUserInfo();
  const expiresAt = new Date(Date.now() + Math.max(0, tokenResponse.expires_in - 10) * 1000).toISOString();

  const user: LoggedInUser = {
    userName: info.sub,
    userId: info.id,
    displayName: Array.isArray(info.name) ? info.name[0] : info.name,
    // The claim arrives as the STRING "True" or "False" (ProfileService: user.IsAdmin.ToString()); !!"False" is true.
    // Display only — the server re-reads TenantManager.IsAdmin for every admin decision.
    isAdmin: String(info.isAdmin).toLowerCase() === 'true',
    selectedRoleId: info.selectedRoleId,
    selectedRoleTitle: info.selectedRoleTitle,
    expiresAt,
  };

  sessionHelper.saveUser(user);
  return user;
}

export function performLogout(): void {
  sessionHelper.clear();
  // Hard navigate so all React state is reset.
  window.location.assign('/login');
}
